const currentScript = document.currentScript;
if (currentScript && currentScript.src) {
	__webpack_public_path__ = currentScript.src.replace(/scripts\/[^/]*$/, '');
}
